import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  appInsights:ApplicationInsights;

  constructor() {
    if (environment.appInsights.isEnable) {
      const appInsightsKey = environment.appInsights.instrumentationKey;
      if (!appInsightsKey) {
          // add custom behavior to handle this scenario
          console.error('Application Insights key not found.');
          return;
      }

      this.appInsights = new ApplicationInsights({
          config: {
              instrumentationKey: appInsightsKey
              // enableAutoRouteTracking: true, // optional: auto-log all route changes
          },
      });

      
      this.appInsights.loadAppInsights();
      console.log('log from appinsights service');
  }
  }
  appInsightsObj() {
    return this.appInsights;
}
}
